//=============================================================================
//                       <--- Developed By Icon Team ---> 02 february 2021
//=============================================================================

// npm packages
import React, { useState, useEffect, useContext, useCallback } from "react";
import { useHistory, useLocation } from "react-router-dom";
import { toast } from "react-toastify";
import DateFnsUtils from "@date-io/date-fns";
import * as moment from "moment";


// custom pages
import { styles } from "./styles";
import jobAuditLog from "apis/JobAuditLog/jobAuditLog";
import Context from "context/context";

// material-ui
import { withStyles } from "@material-ui/core/styles";
import Grid from "@material-ui/core/Grid";
import { Box} from '@material-ui/core';
import Button from "@material-ui/core/Button";
import TextField from "@material-ui/core/TextField";
import MenuItem from "@material-ui/core/MenuItem";
import {
  MuiPickersUtilsProvider,
  KeyboardDatePicker,
} from "@material-ui/pickers";
import IconButton from "@material-ui/core/IconButton";

// material-ui icons
import ArrowBackIcon from "@material-ui/icons/ArrowBack";
import { Fragment } from "react";

//Helpers
import {dateFormat} from "helpers/dataFormat"

// custom TextField
const CssTextField = withStyles({
  root: {
    "& label.Mui-focused": {
      color: "##D3D3D3",
    },
    "& .MuiFormLabel-root": {
      color: "#707070",
    },
    "& .MuiInputBase-input": {
      color: "#707070",
    },
    "& .MuiInput-underline:before": {
      borderBottomColor: "#707070!important",
    },
    "& .MuiInput-underline:after": {
      borderBottomColor: "#707070!important",
    },
    "& .MuiOutlinedInput-root": {
      "& fieldset": {
        borderColor: "#707070",
      },
      "&:hover fieldset": {
        borderColor: "#707070",
      },
      "&.Mui-focused fieldset": {
        borderColor: "#707070",
      },
      "&.MuiOutlinedInput-root": {
        borderRadius: 20,
      },
      "&.MuiOutlinedInput-root": {
        marginTop: 0,
        borderRadius: 20,
      },
    },
  },
})(TextField);

export default function View(props) {
  const { state, dispatch } = useContext(Context);
  const { getJobAuditLog } = jobAuditLog();
  const { updateJobAuditLog  } = jobAuditLog();
  const history = useHistory();
  const location = useLocation();
  const classes = styles();
  ;
  const [res, setRes] = useState(false);
  const [offset, setOffset] = useState(1);





  const [states, setstates] = useState({
    data: {},
    edittedData: {},
    isEdit: false,
    loading: false,
    fetchdata :""
  });

  const {

    data,
    edittedData,
    isEdit,
    loading,
  } = states;

  const setStates = useCallback((newState) => {
    setstates((states) => ({ ...states, ...newState }));
  }, []);

  useEffect(() => {
    if (location?.state?.data) {
      let dataObj = location?.state?.data;
      // console.log(dataObj,"ggggg")
      // setDataObj(dataObj);

    }
  }, []);

  const setDataObj = (dataObj) => {
    setStates({
      data: dataObj});
  };
  // console.log(dataObj,"dataobjj")

  useEffect(() => {
    dispatch({
      type: "SET_PATHNAME",
      payload: ["HOME", "ADMIN", "JobAuditLog", "View"],
    });
    
  }, []);
  useEffect(()=>{
    handleGet()

  },[offset])
  const handleGet = async () => {
    try {
      dispatch({ type: 'SET_LOADING', payload: true })
      let values;
      values = {
        offset: (offset - 1) * 20,
        limit: 20
      };
      let res = await getJobAuditLog(values);
      if (res) {
        setStates({
          data: res.data[0]})
          setDataObj(res.data[0])
        // setCount(res.count);

        setRes(true);
      }
      dispatch({ type: 'SET_LOADING', payload: false })
    } 
    catch (e) {
      console.log({ e });
    }
  };
  
  const handleUpdateResponse = async () => {
    try {
      if (Object.keys(edittedData).length === 0) {
        toast.error("Please alter atleast one field.", {
          toastId: "update-error",
        });
        setStates({ loading: false });
        return;
      }
      let failed = false;
      Object.keys(edittedData).map((o) => {
        if (!edittedData[o] && typeof edittedData[o] != "boolean") {
          failed = true;
        }
      });
      if (failed) {
        toast.error("Cannot update empty field.", {
          toastId: "update-error-2",
        });
        setStates({ loading: false });
        return;
      }

      let values;
      values = {
        ...edittedData
      };
      
      let res = await updateJobAuditLog(values);
      if (res?.data.length>0) {
        setStates({ isEdit: false });; 
        toast.success("Updated", { toastId: "rule-updated" });
        // history.goBack();
      }
      setStates({ loading: false });
    } 
    catch (e) {
      console.log({ e });
    }
  };
  const formatDate = (dateString,key) => {
  
    if((key?.replace(/_/g, ' ')?.toLowerCase() !== 'id') && (key !=  'loyalty_organization_name') && (key != 'loyalty_site_id')){
      if (!dateString) return 'N/A';
      const date = new Date(dateString);
      return moment(date)?.format('YYYY-MM-DD HH:mm');
    } else{
      console.log(key !==  'loyalty_organization_name','loyalty_organization_name',dateString)
      return dateString

    }
 
};

// const formatDateForDisplay = (date) => {
//   return moment(date).format('YYYY-MM-DD HH:mm');
// };

// Function to format the date for backend submission
// const formatDateForBackend = (date) => {
//   return moment(date).format('YYYY-MM-DD HH:mm:ss.SSSSSSS Z'); // Full date format with time and timezone
// };

  return (
    <React.Fragment>
      <Grid container spacing={0} style={{ padding: 10 }}>
        <Grid item xs={12}>
          <IconButton
            onClick={() => {
              setStates({ isEdit: false });; 
            }}
          >
            <ArrowBackIcon style={{ color: "#305698" }} />
          </IconButton>
          {/* <span style={{ fontSize: 18 }}>
            <strong> {'Id'} :</strong> {data?.id}
          </span> */}
         
          {!isEdit && (
            <Button
              className={`${classes.createBtn} dash-1-filter-btn`}
              onClick={() => {
                setStates({ isEdit: true });
              }}
            >
              {'Edit'}
            </Button>
          )}
        </Grid>
      </Grid>
      <Grid container spacing={4} style={{ padding: 10, fontSize: 16 }}>
           <Grid item xs={12}>
          <Grid container spacing={0}>
  
     

{Object.keys(data).map((key) => (

    <Grid container spacing={2}>
      
      <Grid item xs={12} sm={6}  lg={6}>
        <strong>{key.replace(/_/g, ' ')} : </strong> 
      </Grid>
      <Grid item xs={8} sm={4} lg={4}>
        {isEdit ? (
          
          <TextField
            variant="outlined"
            type="text"
            style={{gap:"5%",width:"75%",marginBottom:"2%"}}
            required
            value={states.data[key]}
            onChange={(e) => {
              // const inputValue = e.target.value;
              // const formattedForBackend = formatDateForBackend(inputValue); 
              // setStates((prevState) => ({
              //   ...prevState,
              //   edittedData: {
              //     ...prevState.edittedData,
              //     [key]: e.target.value, // Update the correct key dynamically
              //   },
              // }));
              setStates({
                // key: e.target.value,
                edittedData: {
                  ...edittedData,
                    [key]: e.target.value,
                },
                data: {
                  ...states.data,
                  [key]: e.target.value,
                },
              });
            }}
            
          />
          

        ) : (
          
          <span className={classes.label}>
          {formatDate(states.data[key], key)} {/* Display the formatted date */}
        </span>
        )}
      </Grid>
      <br></br>

    </Grid>

))}

          
          


            
                    </Grid>
        </Grid>
      </Grid>
      <Grid container spacing={0} style={{ padding: 10 }}>
        <Grid item xs={12} style={{ textAlign: "right" }}>
          {
            isEdit && (
              <Fragment>
                <Button
                  className={classes.cancelBtn}
                  onClick={() => {
                    setDataObj(data);
                    setStates({ isEdit: false, edittedData: {} });
                  }}
                >
                  {'Cancel'}
                </Button>
                &nbsp; &nbsp; &nbsp;
                <Button
                  className={classes.submitBtn}
                  onClick={() => {
                    setStates({ loading: true });
                    handleUpdateResponse();
                  }}
                  disabled={loading}
                >
                  {'Update'}
                </Button>
              </Fragment>
            )
          }
        </Grid>
      </Grid>
    </React.Fragment>
  );
}
